module.exports = __webpack_public_path__ + "img/parker-shelton-hero.c34ea4cb.webp";